// extracted by mini-css-extract-plugin
export default {"container":"ModalWindow_container__f59T7","header":"ModalWindow_header__sH9NW","close_btn":"ModalWindow_close_btn__acbR2","content":"ModalWindow_content__FcEBq"};